import React, { useState, useEffect } from "react";

import { Line } from "react-chartjs-2";

import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

const CourseTimeEngagement = ({ learnerTimeData, themeMode }) => {
  var style = getComputedStyle(document.body);

  if (themeMode === "0") {
    var whiteColor = "#f5f5f5";
  } else if (themeMode === "1") {
    var whiteColor = "#010001";
  } else {
    var whiteColor = style.getPropertyValue("--whiteColor");
  }

  const data = {
    labels: learnerTimeData,
    datasets: [
      {
        label: "Course 1",
        data: [12, 20, 15, 25, 12, 15, 10, 15, 10, 15, 25, 15, 20, 15, 20],
        backgroundColor: "#DE7474",
        borderColor: "#DE7474",
        color: "#FFFFFF",
        fill: false,
        borderWidth: 2,
        tension: 0.5,
      },
      {
        label: "Course 2",
        data: [18, 25, 20, 30, 15, 18, 25, 20, 30, 15, 18, 25, 20, 30, 15],
        backgroundColor: "#E5B24D",
        borderColor: "#E5B24D",
        color: "#FFFFFF",
        fill: false,
        borderWidth: 2,
        tension: 0.5,
      },
      {
        label: "Course 3",
        data: [20, 30, 25, 35, 20, 30, 15, 25, 35, 20, 32, 15, 35, 20, 25],
        backgroundColor: "#64EE92",
        borderColor: "#64EE92",
        color: "#FFFFFF",
        fill: false,
        borderWidth: 2,
        tension: 0.5,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: (ctx) => "Course wise learner time engagement",
      },
      tooltip: {
        mode: "index",
      },
      legend: {
        display: true,
        labels: {
          boxWidth: 20,
          boxHeight: 20,
          filter: function (legendItem, data) {
            return legendItem.index != 1;
          },
        },
      },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    scales: {
      x: {
        grid: {
          drawOnChartArea: false,
        },
      },
      y: {
        type: "linear",
        beginAtZero: true,
        grid: {
          drawOnChartArea: false,
        },
        ticks: {
          beginAtZero: true,
          stepSize: 1, // set the step size to 1 to display integer values
        },
        suggestedMin: 0,
        suggestedMax: 10,
      },
    },
    elements: {
      point: {
        radius: 0,
      },
    },
  };

  return (
    <>
      <div className="line-area">
        <Line data={data} options={options} />
      </div>
    </>
  );
};

export default CourseTimeEngagement;
